/**
 * T086: Category Filter Component
 * Dropdown filter for filtering prompts by category
 */

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { useCategories } from '@/hooks/useCategories'
import { Skeleton } from '@/components/ui/skeleton'

interface CategoryFilterProps {
  value: string | undefined
  onChange: (value: string | undefined) => void
}

export function CategoryFilter({ value, onChange }: CategoryFilterProps) {
  const { data, isLoading } = useCategories()
  const categories = data?.data ?? []

  if (isLoading) {
    return <Skeleton className="h-10 w-40" />
  }

  return (
    <Select
      value={value ?? 'all'}
      onValueChange={(v) => onChange(v === 'all' ? undefined : v)}
    >
      <SelectTrigger className="w-40">
        <SelectValue placeholder="All Categories" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All Categories</SelectItem>
        {categories.map((category) => (
          <SelectItem key={category.id} value={category.id}>
            {category.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
